<template>
    <div class="time">
        <template v-if="timeData.days >= 1">
            <span class="number">{{ timeData.days }}</span>
            <span class="text">天</span>
        </template>
        <template v-else>
            <span class="number">{{ timeData.hours | patchPosition }}</span>
            <span class="symbol">时</span>
            <span class="number">{{ timeData.minutes | patchPosition }}</span>
            <span class="symbol">分</span>
            <span class="number">{{ timeData.seconds | patchPosition }}</span>
            <span class="symbol">秒</span>
        </template>
    </div>
</template>

<script>
import util from 'root/blackcard/util';
import serverTime from 'root/blackcard/util/serverTime';
import CountDown from 'root/blackcard/util/countDown';

export default {
    props: {
        endTime: {
            type: Number,
        },
    },
    data: () => ({
        timeout: 0,
    }),
    computed: {
        timeData() {
            const res = util.formatTimeFor48(this.timeout * 1000);
            if (res.hours >= 24) {
                res.days = Math.floor(res.hours / 24);
                res.hours = res.hours % 24;
            }
            Object.keys(res).forEach(k => (res[k] = res[k] < 0 ? 0 : res[k]));
            return res;
        },
    },
    watch: {
        endTime() {
            this.timing();
        },
    },
    created() {
        this.timing();
        window.CountDown = window.CountDown || new CountDown();
        window.CountDown.add(this.timing);
        document.addEventListener('visibilitychange', this.visibilitychange);
    },
    beforeDestroy() {
        window.CountDown.off(this.timing);
        document.removeEventListener('visibilitychange', this.visibilitychange);
    },
    filters: {
        patchPosition(n) {
            const num = util.patchPosition(n);
            return Number.isNaN(num) || Number.isNaN(n) ? '00' : num;
        },
    },
    methods: {
        timing() {
            const endTime = this.endTime;
            this.timeout = Math.round((endTime - serverTime.get()) / 1000);
            if (this.timeout <= 0) this.finish();
            this.$emit('timing');
        },
        finish() {
            this.$emit('finish');
        },
        visibilitychange() {
            if (document.visibilityState === 'visible') this.syncServerTime();
        },
        async syncServerTime() {
            this.$emit('sync-server-time');
        },
    },
};
</script>

<style lang="scss" scoped>
.time {
    display: flex;
    justify-content: center;
    align-items: center;

    &::before {
        content: '续费折扣将在';
        color: #333333;
    }

    &::after {
        content: ' 后结束';
        color: #333333;
    }

    .number {
        background: linear-gradient(180deg, rgba(255, 103, 103, 1) 0%, rgba(255, 56, 56, 1) 100%);
        font-size: 0.24rem;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
        min-width: 0.34rem;
        height: 0.34rem;
        border-radius: 0.04rem;
        line-height: 0.34rem;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0.08rem;
        padding: 0 0.05rem;
    }

    .text {
        color: #333333;
    }

    .symbol {
        color: #333333;
    }
}
</style>
